import MESSAGE_BUS_TOPICS from '@wh/message-bus-topics';

const topicsMap = Object.freeze({
  // Integrator topics
  START: 'wh.sb.widget.start',
  STOP: 'wh.sb.widget.stop',
  INIT_SUCCESS: 'wh.sb.widget.init_success',
  INIT_ERROR: 'wh.sb.widget.init_error',
  START_SUCCESS: 'wh.sb.widget.start_success',
  START_ERROR: 'wh.sb.widget.start_error',
  STOP_SUCCESS: 'wh.sb.widget.stop_success',
  STOP_ERROR: 'wh.sb.widget.stop_error',
  STOP_REQUEST: 'wh.sb.widget.stop_request',
  LOGIN: MESSAGE_BUS_TOPICS.COMMON.LOGIN_STATE,
  LOGIN_STATE_CHANGED: 'wh.common.event.ui.login.flow.state.changed',
  LOGIN_SESSION: 'wh.common.event.session.logIn',
  START_NEW_LOGIN_PROCESS: 'wh.common.command.ui.login.flow.start',
  PAGE_CHANGE: 'navigation.pageChanged',

  // Sportsbook web topics
  NAVIGATE: 'internalRoute',
  ADDTOSLIP_BYO: 'wh.sports.betslip.adapter.byo.legs.add',
});

// Topics aren't exported as standalone exports because we don't want to duplicate code
// and we need a topics map using object.freeze with $Values so that flow checks
// literal topics values and this `.publish('random string', ...)` won't be allowed

export type TopicType = string;
export default topicsMap;
